__webpack_require__.p = "/ui-refresh-demo/referrals/";